<template>
  <div class="container wrap">
    <p style="text-align: center;font-weight:bold;padding: 50px 0 5px 0;font-size: 20px;">中药临床药学服务与调剂教育辅助平台隐私政策
    </p>
    <!-- <p  style="color: black;margin-bottom: 10px;"><br /><span>更新时间：2022年6月6日</span></p>
    <p style="text-align: justify;margin-bottom: 20px;">
      <span style="color: black">开发者：杭州唐古信息科技有限公司</span>
    </p> -->
    <p>
      本隐私政策适用于杭州唐古信息科技有限公司（以下简称“本平台”或“我们”）提供的中药临床药学服务与调剂教育辅助平台（以下简称“调剂教育”）的软件及服务。本隐私政策中中药临床药学服务与调剂教育辅助平台的客户端软件可能会涉及不同应用版本，用户需选择与所安装手机相匹配的软件版本，不同版本的中药临床药学服务与调剂教育辅助平台所提供的功能和服务可能有所不同。<br />
      本平台深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。本平台致力于维持您对本平台的信任，恪守以下原则保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，本平台承诺，本平台将按业界成熟的安全标准采取相应的安全保护措施来保护您的个人信息。<br />为了更好的保护您的个人信息，建议您仔细阅读更新后的隐私政策。如您对本隐私政策条款有任何异议或疑问，您可通过本隐私政策第九条公布的联系方式与本平台联系。
    </p>
    <h4><span style="color: black">目录</span></h4>
    <p>
      一、本平台如何收集和使用您的个人信息<br />
      二、本平台如何使用Cookie和同类技术<br />
      三、本平台如何共享、转让、公开披露您的个人信息<br />
      四、本平台如何保护您的个人信息<br />
      五、您的权利<br />
      六、本平台如何处理儿童的个人信息<br />
      七、您的个人信息如何在全球范围转移<br />
      八、本隐私政策如何更新<br />
      九、如何联系我们<br />
      十、争议解决
    </p>
    <h4><span style="color: black">一、本平台如何收集和使用您的个人信息</span></h4>
    <p>
      1、个人信息和个人敏感信息定义<br />
      个人信息，指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本平台实际具体收集的个人信息种类以下文描述为准。<br />个人敏感信息，指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。实际具体收集的个人敏感信息种类以下文描述为准。本平台实际具体收集的个人敏感信息种类以下文描述为准。<br />
      2、本平台如何收集和使用您的个人信息<br />
      （1）登录调剂教育<br />
        您创建并登录调剂教育时，您需提供您的手机号，创建的用户名和密码。如果不创建账号，将会影响您使用调剂教育的部分浏览功能，和会影响您发表评论等附加业务功能。
    </p>
      <p>1.后台运行</p>
      调剂教育在后台运行时，会收集您的设备标识信息（MAC地址、DEVICE_id、IMEI、设备序列号）和日志信息，用于信息推送、安全风控。如您拒绝，不影响您使用调剂教育。
      <br/>
       另外调剂教育在后台运行时，还会收集您设备的存储权限，用于下载、缓存文件。如您拒绝，不影响您使用调剂教育。
    <p> 
      2.您理解并同意，以下情形中，本平台收集、使用您的个人信息不必另行征得您的授权同意：<br />
      (1)&nbsp;本平台履行法律法规规定的义务相关的；<br />
      (2)&nbsp;与国家安全、国防安全直接相关的；<br />
      (3)&nbsp;与公共安全、公共卫生、重大公共利益直接相关的；<br />
      (4)&nbsp;与刑事侦查、起诉、审判和判决执行等直接相关的；<br />
      (5)&nbsp;出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您授权同意的；<br />
      (6)&nbsp;所涉及的您的信息是您自行向社会公众公开的；<br />
      (7)&nbsp;根据您要求签订和履行合同所必需的；<br />
      (8)&nbsp;从合法公开披露的信息中收集您的个人信息的，如合法的新闻报道、政府信息公开等渠道；<br />
      (9)&nbsp;维护所提供本平台调剂教育产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的故障；<br />
      (10)&nbsp;法律法规等规定的其他情形。
    </p>
    <h4><span style="color: black">二、本平台如何使用Cookie和同类技术</span></h4>
    <p>
      为了收集前述个人信息，本平台和第三方授权合作伙伴均使用技术，通过理解和记忆您的特定使用偏好使用以下技术，为您提供更加个性化的体验：<br />1、Cookie：为确保调剂教育正常运转，本平台会在您的移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，网站能够存储您的偏好等数据。本平台不会将Cookie用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。<br />2、SDK：SDK是本平台嵌入调剂教育的一组工具和/或代码，允许第三方授权合作伙伴收集有关用户如何与服务交互的信息；
    </p>
    <h4>
      <span style="color: black">三、本平台本平台如何共享、转让、公开披露您的个人信息</span>
    </h4>
    <p>
      1、共享<br />本平台不会与本平台以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：<br />（1）事先已获得您的明确授权或同意；<br />（2）根据适用的法律法规、法律程序、政府的强制命令或司法裁定而需共享您的个人信息；<br />（3）在法律要求或允许的范围内，为了保护调剂教育及其用户或社会公众的利益、财产或安全免遭损害而有必要提供您的个人信息给第三方；<br />（4）您的个人信息会在本平台关联公司之间共享。本平台只会共享必要的个人信息，且这种共享亦受本隐私政策声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意；<br />（5）为实现本隐私政策中声明的目的，本平台的某些服务将由授权合作伙伴提供。本平台会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，在发放实体奖品时，本平台必须与物流服务提供商共享您的个人信息才能安排送货，或者安排合作伙伴提供服务。本平台仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。本平台的合作伙伴无权将共享的个人信息用于任何其他用途。如果您拒绝本平台的合作伙伴在提供服务时收集为提供服务所必需的个人信息，将导致您无法在调剂教育中使用该第三方服务。本平台的授权合作伙伴包括以下几大类型：<br />①委托本平台进行信息推广和广告投放的合作伙伴：您确认本平台有权与委托本平台进行信息推广和广告投放的合作伙伴共享本平台使用您的相关信息集合形成的间接用户画像、去标识化或匿名化处理后的分析/统计类信息，以帮助其进行广告或决策建议、提高广告有效触达率、进一步了解用户需求。本平台承诺：未经您的同意，本平台不会与其共享可以识别您身份的个人信息。<br />②第三方SDK类服务商：
    </p>
    <!-- <figure class="table"> -->
    <!-- <table border="1px soild black;" width="800px">
      <thead>
        <tr>
          <th width="6%"><strong>序号</strong></th>
          <th width="10%"><strong>SDK名称</strong></th>
          <th width="15%"><strong>场景描述</strong></th>
          <th width="27%"><strong>个人信息字段</strong></th>
          <th width="27%"><strong>隐私政策链接</strong></th>
          <th width="15%"><strong>第三方SDK名称</strong></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>有道</td>
          <td>请求广告及推送信息</td>
          <td>
            <strong
              >屏幕参数，设备商机型，操作系统，设备唯一设备识别码，个人常用设备信息，运营商信息，设备类型，设备序列号，地理位置信息</strong
            >
          </td>
          <td>
            <a
              href="https://links.jianshu.com/go?to=http://shared.youdao.com/dict/market/youdaoInc-v2.1/index.html%23/CN"
              >http://shared.youdao.com/dict/market/youdaoInc-v2.1/index.html#/CN</a
            >
          </td>
          <td>北京网易有道计算机系统有限公司</td>
        </tr>
        <tr>
          <td>2</td>
          <td>穿山甲</td>
          <td>请求广告及推送信息</td>
          <td>
            <strong
              >ip地址，设备信息，屏幕参数，设备唯一设备识别码，设备商机型，操作系统，MAC设备地址，运营商信息，设备类型，设备序列号，地理位置信息、读取WIFI扫描结果、读取当前运行应用进程、读取WIFI的BSSID、读取AndroidID、读取DEVICEID、读取当前运行应用进程、读取WIFI的SSID、读取精细位置信息、监视精细行动轨迹、读取粗略位置信息、读取文件、写入文件</strong
            >
          </td>
          <td>
            <a
              href="https://links.jianshu.com/go?to=https://www.pangle.cn/privacy"
              >https://www.pangle.cn/privacy</a
            >
          </td>
          <td>湖北今日头条科技有限公司</td>
        </tr>
        <tr>
          <td>3</td>
          <td>友盟SDK</td>
          <td>统计分析、推送消息、安全校验</td>
          <td>
            <strong
              >设备唯一标识码（IMEI/androidID/IDFA/OPENUDID/GUID、SIM卡IMSI信息）、设备MAC地址、您的用户名、每次使用产品的时长、用于反作弊的地理位置信息、软件安装列表、设备序列号读取AndroidID、读取DEVICEID、读取MAC地址、读取IMSI</strong
            >
          </td>
          <td>
            <a
              href="https://links.jianshu.com/go?to=https://www.umeng.com/policy"
              >https://www.umeng.com/policy</a
            >
          </td>
          <td>友盟同欣（北京）科技有限公司</td>
        </tr>
        <tr>
          <td>4</td>
          <td>小米PUSH</td>
          <td>推送消息</td>
          <td><strong>设备标识信息（IMEI、MAC地址）</strong></td>
          <td>
            <a
              href="https://links.jianshu.com/go?to=https://dev.mi.com/console/doc/detail?pId=1339"
              >https://dev.mi.com/console/doc/detail?pId=1339</a
            >
          </td>
          <td>小米科技</td>
        </tr>
        <tr>
          <td>5</td>
          <td>OPPO PUSH</td>
          <td>推送消息</td>
          <td><strong>设备标识信息（IMEI、MAC地址）</strong></td>
          <td>
            <a
              href="https://links.jianshu.com/go?to=https://open.oppomobile.com/wiki/doc%23id=10288"
              >https://open.oppomobile.com/wiki/doc#id=10288</a
            >
          </td>
          <td>广东欢太科技有限公司</td>
        </tr>
        <tr>
          <td>6</td>
          <td>魅族PUSH</td>
          <td>推送消息</td>
          <td>
            <strong
              >设备标识信息（IMEI、MAC地址）、手机号及位置信息、读取设备运营商、读取WIFI的BSSID、读取DEVICEID、读取本机号码、读取WIFI扫描结果、读取已安装包名列表、读取粗略位置信息、写入文件</strong
            >
          </td>
          <td>
            <a
              href="https://links.jianshu.com/go?to=https://open.flyme.cn/open-web/views/push.html"
              >https://open.flyme.cn/open-web/views/push.html</a
            >
          </td>
          <td>魅族科技</td>
        </tr>
        <tr>
          <td>7</td>
          <td>华为PUSH</td>
          <td>推送消息</td>
          <td><strong>设备标识信息（IMEI、MAC地址）</strong></td>
          <td>
            <a
              href="https://links.jianshu.com/go?to=https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides-V5/privacy-statement-0000001050042021-V5"
              >https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides-V5/privacy-statement-0000001050042021-V5</a
            >
          </td>
          <td>华为技术有限公司</td>
        </tr>
        <tr>
          <td>8</td>
          <td>广点通SDK</td>
          <td>请求广告及推送信息</td>
          <td>
            <strong
              >ip地址，设备信息，屏幕参数，设备唯一设备识别码，设备商机型，操作系统，个人常用设备信息，运营商信息，设备类型，设备序列号，地理位置信息、读取当前运行应用进程、读取精细位置信息、动态加载</strong
            >
          </td>
          <td>
            <a
              href="https://links.jianshu.com/go?to=https://www.tencent.com/zh-cn/privacy-policy.html"
              >https://www.tencent.com/zh-cn/privacy-policy.html</a
            >
          </td>
          <td>腾讯科技（深圳）有限公司</td>
        </tr>
        <tr>
          <td>9</td>
          <td>神策数据SDK</td>
          <td>统计数据、安全校验</td>
          <td>
            <strong
              >获取MAC地址、设备IMEI、检测网络状态、Androidid、设备序列号、读取当前运行应用进程、读取AndroidID、读取设备运营商</strong
            >
          </td>
          <td>
            <a
              href="https://links.jianshu.com/go?to=https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_privacy_policy-22255998.html"
              >https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_privacy_policy-22255998.html</a
            >
          </td>
          <td>神策网络科技 (北京) &nbsp;有限公司</td>
        </tr>
        <tr>
          <td>10</td>
          <td>请求广告及推送信息</td>
          <td>语音朗读</td>
          <td>
            <strong
              >ip地址，设备信息，屏幕参数，设备唯一设备识别码，设备商机型，操作系统，MAC设备地址，运营商信息，设备类型，设备序列号，地理位置信息</strong
            >
          </td>
          <td>
            <a
              href="https://links.jianshu.com/go?to=https://www.voiceads.cn/ai-help.html?id=220"
              >https://www.voiceads.cn/ai-help.html?id=220</a
            >
          </td>
          <td>科大讯飞股份有限公司</td>
        </tr>
        <tr>
          <td>11</td>
          <td>admobile</td>
          <td>请求广告及推送信息</td>
          <td>
            <strong
              >ip地址，设备信息，屏幕参数，设备唯一设备识别码，设备商机型，操作系统，个人常用设备信息，运营商信息，设备类型，序列号，地理位置信息</strong
            >
          </td>
          <td>
            <a
              href="https://links.jianshu.com/go?to=https://www.tencent.com/zh-cn/privacy-policy.html"
              >https://www.tencent.com/zh-cn/privacy-policy.html</a
            >
          </td>
          <td>杭州艾狄墨搏数字科技有限公司</td>
        </tr>
      </tbody>
    </table> -->
    <!-- </figure> -->
    <p>
      <strong
        >为了最大程度保障您的信息安全，本平台建议您在使用第三方SDK服务前先行查看其隐私条款。如果您最不希望其个人信息处理和使用，您可以登录网址第三方SDK网站进行退出操作。</strong
      ><br />对本平台与之共享个人信息的公司、组织和个人，本平台会与其签署严格的保密协定，要求他们按照本平台的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。<br />2、转让<br />本平台不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：<br />（1）获得您的明确同意后，本平台会向其他方转让您的个人信息；<br />（2）在涉及合并、收购或破产清算时，如涉及到个人信息转让，本平台会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则本平台将要求该公司、组织重新向您征求授权同意。<br />3、公开披露<br />本平台仅会在以下情况下，公开披露您的个人信息：<br />（1）获得您明确同意后；<br />（2）基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，本平台会公开披露您的个人信息。
    </p>
    <h4><span style="color: black">四、本平台如何保护您的个人信息</span></h4>
    <p>
      1、本平台已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。本平台会采取一切合理可行的措施，保护您的个人信息。例如本平台使用加密技术确保数据的保密性；本平台会使用受信赖的保护机制防止数据遭到恶意攻击；本平台会部署访问控制机制，确保只有授权人员才可访问个人信息；以及本平台会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。<br />
      2、本平台在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内，不会进行任何数据出境。您的个人信息存储期限为10年；10年期满后如您继续在使用调剂教育服务的，该等服务必需的个人信息的存储期限再续10年，如届时您已经不再使用调剂教育服务的，本平台将及时删除您的个人信息。
    </p>
    
      <p class="shsj">
        1.<strong>尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，本平台将尽力确保您提供给我们的个人信息的安全性。</strong
        >
      </p>
    
    <p class="shsj">
      2.<strong>您知悉并理解，您接入本平台的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的帐号密码及相关个人信息透露给他人。</strong
      >
    </p>
    <h4><span style="color: black">五、您的权利</span></h4>
    <p>
      按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，本平台保障您对自己的个人信息行使以下权利：<br />1、访问您的个人信息<br />您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：<br />（1）访问头像、昵称、性别、生日等基本信息：<br />①进入调剂教育后，点击“我的”<br />②点击头像栏<br />③进行信息查询和访问<br />2、更正您的个人信息<br />当您发现本平台处理的关于您的个人信息有错误时，您有权要求本平台做出更正。您可以通过“1访问您的个人信息”中罗列的方式提出更正申请。<br />3、删除您的个人信息<br />在以下情形中，您可以向本平台提出删除个人信息的请求：<br />（1）如果本平台处理个人信息的行为违反法律法规；<br />（2）如果本平台收集、使用您的个人信息，却未征得您的同意；<br />（3）如果本平台处理个人信息的行为违反了与您的约定；<br />（4）如果您不再使用本平台的产品或服务，或您注销了帐号；<br />（5）如果本平台不再为您提供产品或服务。<br />若本平台决定响应您的删除请求，本平台还将同时通知从本平台获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。<br />当您从本平台的服务中删除信息后，本平台不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。<br />4、撤回同意<br />您可以通过关闭设备功能改变您授权本平台继续收集个人信息的范围或撤回您的授权。您还可以通过注销帐户的方式，撤回本平台继续收集您个人信息的全部授权。<br />5、退出帐户<br />您随时可退出此前注册的帐户，您可以通过以下方式自行操作：<br />（1）进入调剂教育后，点击“我的”<br />（2）点击“我的设置”<br />（3）点击“退出登录”<br />在退出帐户之后，本平台将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。<br />在以下情形中，按照法律法规要求，本平台将无法响应您的请求：<br />（1）与国家安全、国防安全直接相关的；<br />（2）与公共安全、公共卫生、重大公共利益直接相关的；<br />（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；<br />（4）有充分证据表明您存在主观恶意或滥用权利的；<br />（5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；<br />（6）涉及商业秘密的。<br />6、注销账号<br />您随时可以注销此前注册的账号，在账户注销后，原账户相关信息会被清空且无法找回且无法进行以下操作：<br />（1）账号中的个人信息、历史信息、书架记录等将被清空；<br />（2）账号中的权益将被取消，已购买会员产品将视为自动放弃；<br />（3）账号中的邀请好友关系将被清空；<br />（4）账号中的签到记录将被清空；<br />（5）账号中的金币余额、现金余额、书币、书券将被清空；<br />在以下情形中，按照法律法规要求，本平台无法响应您的请求：<br />（1）与国家安全、国防安全直接相关的；<br />（2）与公共安全、公共卫生、重大公共利益直接相关的；<br />（3）与犯罪侦查、起诉、审判和判决执行等执行相关的；<br />（4）有充分证据表明您存在主观恶意或滥用权力的；<br />（5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；<br />（6）涉及商业秘密的。<br />注销操作<br /><span
        style="color: black"
        >本平台提供账号删除服务，如果您要删除账号，请通过邮箱kefu@tangusoft.com沟通，我们将在15个工作日内处理。</span
      >
    </p>
    <h4><span style="color: black">六、本平台如何处理儿童的个人信息</span></h4>
    <p>
      本平台的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不得创建自己的用户帐户。<br />对于经父母同意而收集儿童个人信息的情况，本平台只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。<br />尽管当地法律和习俗对儿童的定义不同，但本平台将不满18周岁的任何人均视为儿童。<br />如果本平台发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。
    </p>
    <h4><span style="color: black">七、您的个人信息如何在全球范围转移</span></h4>
    <p>
      目前本平台不会跨境传输或存储您的个人信息。将来如需跨境传输或存储的，本平台会向您告知信息出境的目的、接收方、安全保障措施和安全风险，并征得您的同意。
    </p>
    <h4><span style="color: black">八、本隐私政策如何更新</span></h4>
    <p>
      本平台的隐私政策可能变更。未经您明确同意，本平台不会削减您按照本隐私政策所应享有的权利。本平台会在本页面上发布对本隐私政策所做的任何变更。对于重大变更，本平台还会提供更为显著的通知。本隐私政策所指的重大变更包括但不限于：<br />1、本平台的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；<br />2、本平台在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；<br />3、个人信息共享、转让或公开披露的主要对象发生变化；<br />4、您参与个人信息处理方面的权利及其行使方式发生重大变化；<br />5、本平台负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；<br />6、个人信息安全影响评估报告表明存在高风险时。<br />本平台还会将本隐私政策的旧版本存档，供您查阅。
    </p>
    <h4><span style="color: black">九、如何联系本平台</span></h4>
    <p style="text-align: justify">
      如您对本隐私政策有任何疑问、意见或建议，您可以通过如下方式与本平台联系。一般情况下，本平台将在15个工作日内回复您。<br />Email：<a
        href="mailto:kefu@tangusoft.com"
        style="color: black;">kefu@tangusoft.com</a
      ><br />电 话：<span style="background-color: white; color: #666666"
        >0571 -&nbsp;28131127</span
      >
    </p>
    <h4><span style="color: black">十、争议解决</span></h4>
    <p>
      因本隐私政策产生的及与本隐私政策相关的任何争议，应提交本协议签订地（即杭州市西湖区）有管辖权的法院诉讼解决。
    </p>
    <p>
      <br />链接：https://ysfwzx.365yyf.com<br />著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。
    </p>
    <p>&nbsp;</p>
  </div>
</template>

<style scoped>
.container {
  /* text-align: center; */
  width: 800px;
  line-height: 1.8em;
  word-wrap:break-word;
}
h4{
    padding: 15px 0;
}
.shsj{
    text-indent: 2em;
}
table{
    table-layout: fixed;
 word-wrap:break-word;
    /* width: 50%; */
}
a{
    text-decoration: underline;  
    color: blue;
}
</style>